import * as R from 'ramda';

import generateId from '../../utils/generateId';

const send =
    () =>
    (state, text, options = {}, shouldAutoClose, hasActionButton) => {
        const userClientId = state.user.selectedUserClientId;
        const notificationsLens = R.lensPath([
            'clients',
            userClientId,
            'notifications',
        ]);

        return R.over(
            notificationsLens,
            R.append({
                id: generateId(),
                text,
                options,
                shouldAutoClose,
                hasActionButton,
            }),
            state,
        );
    };

export default send;
